let messages = [
  {
    id: "6035305bb0cc0058ebecab4b",
    from: {
      id: "e2008@isdb.onmicrosoft.com",
      userName: "e2008@isdb.onmicrosoft.com",
      displayName: "Anastasios Georgousakis",
      emailAddress: "e2008@isdb.onmicrosoft.com",
      organization: "Noema",
      jobTitle: "Software Engineer",
      telephone: "N/A",
      country: {
        name: "Greece",
      },
      roles: ["Agency"],
    },
    body: "test 1",
    sendAt: "2021-02-23T18:42:03",
  },
  {
    id: "60368a86f341ec6d318d5025",
    from: {
      id: "e2066@isdb.onmicrosoft.com",
      userName: "e2066@isdb.onmicrosoft.com",
      displayName: "Jean-Paul Davoutian",
      emailAddress: "e2066@isdb.onmicrosoft.com",
      organization: "Noema",
      jobTitle: "Software Engineer",
      telephone: "N/A",
      country: {
        name: "Greece",
      },
      roles: ["Agency"],
    },
    body: "message 2",
    sendAt: "2021-02-24T19:19:02",
  },
  {
    id: "60369286f341ec6d318d5026",
    from: {
      id: "e2008@isdb.onmicrosoft.com",
      userName: "e2008@isdb.onmicrosoft.com",
      displayName: "Anastasios Georgousakis",
      emailAddress: "e2008@isdb.onmicrosoft.com",
      organization: "Noema",
      jobTitle: "Software Engineer",
      telephone: "N/A",
      country: {
        name: "Greece",
      },
      roles: ["Agency"],
    },
    body: "test 3",
    sendAt: "2021-02-24T19:53:10",
  },
  {
    id: "6036928bf341ec6d318d5027",
    from: {
      id: "e2008@isdb.onmicrosoft.com",
      userName: "e2008@isdb.onmicrosoft.com",
      displayName: "Anastasios Georgousakis",
      emailAddress: "e2008@isdb.onmicrosoft.com",
      organization: "Noema",
      jobTitle: "Software Engineer",
      telephone: "N/A",
      country: {
        name: "Greece",
      },
      roles: ["Agency"],
    },
    body: "test 4",
    sendAt: "2021-02-24T19:53:15",
  },
  {
    id: "603694adf341ec6d318d5029",
    from: {
      id: "e10636@isdb.onmicrosoft.com",
      userName: "e10636@isdb.onmicrosoft.com",
      displayName: "Naman Anand",
      emailAddress: "e10636@isdb.onmicrosoft.com",
      organization: "Noema",
      jobTitle: "Software Engineer",
      telephone: "N/A",
      country: {
        name: "India",
      },
      roles: ["Agency"],
    },
    body: "test 5",
    sendAt: "2021-02-24T20:02:11",
  },
  {
    id: "603694adf341ec6d318d5028",
    from: {
      id: "e2008@isdb.onmicrosoft.com",
      userName: "e2008@isdb.onmicrosoft.com",
      displayName: "Anastasios Georgousakis",
      emailAddress: "e2008@isdb.onmicrosoft.com",
      organization: "Noema",
      jobTitle: "Software Engineer",
      telephone: "N/A",
      country: {
        name: "Greece",
      },
      roles: ["Agency"],
    },
    body: "test 5",
    sendAt: "2021-02-24T20:02:21",
  },
];

export default messages;
